import lessRequire from '../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import classname from 'classname';

lessRequire('modules/shared/error.less');

const Error = props => {
	let { isNotFoundPage, intl } = props;

	const language = intl && intl.language;

	const className = classname({
		'not-found-banner': isNotFoundPage,
		'error-banner': !isNotFoundPage,
		'error-banner-ru': !isNotFoundPage && language && language === 'ru'
	});

	return (
		<div className="error-page container">
			<div className="content-container">
				{
					process.env.CPA_ENV == 'everad'
						? (
							<div className={className} />
						) : (
							<h1 className="error-msg font-proxima-nova-semibold">{isNotFoundPage ? '404' : intl('Ой')}</h1>
						)
				}

				<p className="error-page__title font-proxima-nova-bold">
					{props.isNotFoundPage ? intl('Страница не найдена!') : intl('Ошибка!')}
				</p>
				<p className="error-page__desc">
					{intl('Что-то пошло не так, или страница не найдена. Вы можете перейти на главную страницу или обратиться в')}
					{' '}
					<a href="tickets/">{intl('поддержку!')}</a>
				</p>
				<a className="error-page__button font-proxima-nova-regular" href="/">
					<span>{intl('На дашборд')}</span>
				</a>
			</div>
		</div>
	);
};

Error.propTypes = {
	isNotFoundPage: PropTypes.bool,
	intl: PropTypes.func
};

export default Error;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/error.js